// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"upload_uploadWrapper__TnYBT"};